// Activity events emitted by `content/tags`. Tag mutations are
// curator actions; the audit trail is short by design.
import { z } from 'zod';
export const TAG_ACTIVITY_KINDS = {
    Created: 'tag.created',
    Updated: 'tag.updated',
    Archived: 'tag.archived',
    Restored: 'tag.restored',
    AttachedToArticle: 'tag.attached-to-article',
    DetachedFromArticle: 'tag.detached-from-article',
};
export const TAG_ACTIVITY_KIND_GLOB = 'tag.*';
export const TagCreatedEvent = z.object({
    type: z.literal('tag.created'),
    tagId: z.string().uuid(),
    byUserId: z.string().uuid(),
    slug: z.string(),
    name: z.string(),
    occurredAt: z.string().datetime({ offset: true }),
});
export const TagUpdatedEvent = z.object({
    type: z.literal('tag.updated'),
    tagId: z.string().uuid(),
    byUserId: z.string().uuid(),
    changedFields: z.array(z.string()),
    occurredAt: z.string().datetime({ offset: true }),
});
export const TagArchivedEvent = z.object({
    type: z.literal('tag.archived'),
    tagId: z.string().uuid(),
    byUserId: z.string().uuid(),
    occurredAt: z.string().datetime({ offset: true }),
});
export const TagRestoredEvent = z.object({
    type: z.literal('tag.restored'),
    tagId: z.string().uuid(),
    byUserId: z.string().uuid(),
    occurredAt: z.string().datetime({ offset: true }),
});
export const TagAttachedToArticleEvent = z.object({
    type: z.literal('tag.attached-to-article'),
    tagId: z.string().uuid(),
    articleId: z.string().uuid(),
    byUserId: z.string().uuid(),
    occurredAt: z.string().datetime({ offset: true }),
});
export const TagDetachedFromArticleEvent = z.object({
    type: z.literal('tag.detached-from-article'),
    tagId: z.string().uuid(),
    articleId: z.string().uuid(),
    byUserId: z.string().uuid(),
    occurredAt: z.string().datetime({ offset: true }),
});
//# sourceMappingURL=events.js.map